/* =====================
   Ajoutez ici votre propre javascript personnalisé
   ===================== */

/* =====================================================================
   Upsell post-panier — Trio Gourmand -> Chantilly de Karité 200 ml -50%
   Ajouté par Claude pour Mamans d'ici et d'ailleurs (offre de lancement)
   - Se déclenche à CHAQUE fois que le Trio Gourmand est ajouté au
     panier (même en plusieurs fois), quel que soit l'endroit du site
     où l'ajout a lieu.
   - Ajoute la Chantilly 200 ml en un clic ; la réduction de 7,45 €
     (remise automatique Shopify "Achetez X, obtenez Y") s'applique et
     se retire toute seule selon le contenu du panier, sans code ici.
   - Ne se réaffiche pas si la Chantilly 200 ml est déjà dans le panier
     (inutile de proposer une offre déjà acceptée).
   ===================================================================== */
(function () {
  var TRIO_VARIANT_ID = 53858535309640;
  var OFFER_VARIANT_ID = 53282139799880;
  var OFFER_IMAGE = "https://cdn.shopify.com/s/files/1/0812/6545/9528/files/Chantilly_de_karit_de_Guin_e.png?v=1771941463&width=300";

  function extractVariantIds(body) {
    if (!body) return [];
    try {
      if (body instanceof FormData) {
        var id = body.get("id");
        return id ? [Number(id)] : [];
      }
      var data = typeof body === "string" ? JSON.parse(body) : body;
      if (data.items && Array.isArray(data.items)) {
        return data.items.map(function (it) {
          return Number(it.id);
        });
      }
      if (data.id) return [Number(data.id)];
    } catch (e) {}
    return [];
  }

  async function cartHasVariant(variantId) {
    try {
      var res = await fetch("/cart.js");
      var cart = await res.json();
      return cart.items.some(function (it) {
        return it.variant_id === variantId;
      });
    } catch (e) {
      return false;
    }
  }

  var originalFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    var isAddToCart = url.indexOf("/cart/add") !== -1;
    var fetchPromise = originalFetch(input, init);

    if (isAddToCart) {
      var body = init && init.body;
      var variantIds = extractVariantIds(body);
      var isTrio = variantIds.indexOf(TRIO_VARIANT_ID) !== -1;

      if (isTrio) {
        fetchPromise
          .then(async function (response) {
            if (!response || !response.ok) return;
            var hasOffer = await cartHasVariant(OFFER_VARIANT_ID);
            if (hasOffer) return;
            setTimeout(showTrioUpsellModal, 700);
          })
          .catch(function () {});
      }
    }

    return fetchPromise;
  };

  function closeModal(overlay) {
    overlay.classList.remove("mdi-upsell-open");
    setTimeout(function () {
      overlay.remove();
      document.documentElement.classList.remove("mdi-upsell-lock");
    }, 200);
  }

  function showTrioUpsellModal() {
    if (document.getElementById("mdi-trio-upsell-overlay")) return;

    var overlay = document.createElement("div");
    overlay.id = "mdi-trio-upsell-overlay";
    overlay.innerHTML =
      '<div class="mdi-upsell-card" role="dialog" aria-modal="true" aria-labelledby="mdi-upsell-title">' +
      '<button type="button" class="mdi-upsell-close" aria-label="Fermer">' +
      '<svg width="13" height="13" viewBox="0 0 12 12" fill="none"><path d="M1 1L11 11M11 1L1 11" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>' +
      "</button>" +
      '<div class="mdi-upsell-confirm">' +
      '<span class="mdi-upsell-check"><svg width="11" height="9" viewBox="0 0 11 9" fill="none"><path d="M1 4.3L4 7.3L10 1.2" stroke="#5F8A57" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
      "Trio Gourmand ajouté à ton panier" +
      "</div>" +
      '<div class="mdi-upsell-visual">' +
      '<img src="' + OFFER_IMAGE + '" alt="Chantilly de Karité 200 ml" loading="lazy">' +
      "</div>" +
      '<div class="mdi-upsell-badge-wrap"><span class="mdi-upsell-badge">Offre spéciale lancement · −50 %</span></div>' +
      '<h2 id="mdi-upsell-title" class="mdi-upsell-heading">Une petite douceur en plus ? 🤎</h2>' +
      '<p class="mdi-upsell-body">Pour célébrer le tout premier lancement du Trio Gourmand, profite exceptionnellement d’une Chantilly de Karité 200&nbsp;ml à −50&nbsp;%, le temps de faire une jolie réserve à prix doux.</p>' +
      '<div class="mdi-upsell-price-row">' +
      "<div>" +
      '<div class="mdi-upsell-price-label">Chantilly de Karité · 200 ml</div>' +
      '<div class="mdi-upsell-price-values">' +
      '<span class="mdi-upsell-price-old">14,95&nbsp;€</span>' +
      '<span class="mdi-upsell-price-new">7,50&nbsp;€</span>' +
      "</div></div>" +
      '<span class="mdi-upsell-save">− 7,45&nbsp;€</span>' +
      "</div>" +
      '<div class="mdi-upsell-shipping">' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M2 6H14V16H2V6Z" stroke="#8A6B48" stroke-width="1.6" stroke-linejoin="round"/><path d="M14 9H18L21 12.5V16H14V9Z" stroke="#8A6B48" stroke-width="1.6" stroke-linejoin="round"/><circle cx="6" cy="18" r="1.8" stroke="#8A6B48" stroke-width="1.6"/><circle cx="17.5" cy="18" r="1.8" stroke="#8A6B48" stroke-width="1.6"/></svg>' +
      '<span>Ton panier passe à <strong>57,40&nbsp;€</strong> — la livraison est offerte&nbsp;!</span>' +
      "</div>" +
      '<button type="button" class="mdi-upsell-cta">' +
      '<span class="mdi-upsell-cta-label">Oui, j’ajoute ma Chantilly à 7,50&nbsp;€</span>' +
      "</button>" +
      '<div class="mdi-upsell-decline-wrap"><a href="#" class="mdi-upsell-decline">Non merci, je garde uniquement mon Trio</a></div>' +
      "</div>";

    document.body.appendChild(overlay);
    document.documentElement.classList.add("mdi-upsell-lock");
    requestAnimationFrame(function () {
      overlay.classList.add("mdi-upsell-open");
    });

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) closeModal(overlay);
    });
    overlay.querySelector(".mdi-upsell-close").addEventListener("click", function () {
      closeModal(overlay);
    });
    overlay.querySelector(".mdi-upsell-decline").addEventListener("click", function (e) {
      e.preventDefault();
      closeModal(overlay);
    });

    overlay.querySelector(".mdi-upsell-cta").addEventListener("click", async function () {
      var btn = overlay.querySelector(".mdi-upsell-cta");
      var label = overlay.querySelector(".mdi-upsell-cta-label");
      btn.disabled = true;
      var originalText = label.textContent;
      label.textContent = "Ajout en cours…";

      try {
        var response = await originalFetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: OFFER_VARIANT_ID, quantity: 1 }] }),
        });
        if (typeof window.updateCartContents === "function") {
          window.updateCartContents(response);
        }
        if (document.querySelector("#offcanvas-cart") && window.bootstrap) {
          bootstrap.Offcanvas.getOrCreateInstance("#offcanvas-cart").show();
        }
      } catch (e) {
        label.textContent = originalText;
        btn.disabled = false;
        return;
      }

      closeModal(overlay);
    });
  }

  var style = document.createElement("style");
  style.textContent =
    "html.mdi-upsell-lock{overflow:hidden;}" +
    "#mdi-trio-upsell-overlay{position:fixed;inset:0;z-index:2000;display:flex;align-items:center;justify-content:center;padding:20px;background:rgba(33,18,2,0);transition:background .25s ease;font-family:'Poppins',system-ui,sans-serif;}" +
    "#mdi-trio-upsell-overlay.mdi-upsell-open{background:rgba(33,18,2,.55);}" +
    "#mdi-trio-upsell-overlay .mdi-upsell-card{position:relative;width:100%;max-width:420px;max-height:90vh;overflow-y:auto;background:#FFFAF6;border-radius:24px;box-shadow:0 30px 60px -20px rgba(20,10,2,.45);padding:24px 24px 26px;opacity:0;transform:translateY(14px) scale(.98);transition:opacity .25s ease, transform .25s ease;}" +
    "#mdi-trio-upsell-overlay.mdi-upsell-open .mdi-upsell-card{opacity:1;transform:translateY(0) scale(1);}" +
    "#mdi-trio-upsell-overlay .mdi-upsell-close{position:absolute;top:14px;right:14px;width:28px;height:28px;border-radius:50%;border:none;background:rgba(33,18,2,.05);color:#9C8874;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0;}" +
    "#mdi-trio-upsell-overlay .mdi-upsell-confirm{display:flex;align-items:center;gap:8px;font-size:12.5px;color:#8A7562;font-weight:500;margin-bottom:14px;}" +
    "#mdi-trio-upsell-overlay .mdi-upsell-check{width:20px;height:20px;border-radius:50%;background:#E4EEE3;display:flex;align-items:center;justify-content:center;flex-shrink:0;}" +
    "#mdi-trio-upsell-overlay .mdi-upsell-visual{display:flex;justify-content:center;margin-bottom:14px;}" +
    "#mdi-trio-upsell-overlay .mdi-upsell-visual img{width:128px;height:128px;object-fit:cover;border-radius:16px;box-shadow:0 10px 24px -10px rgba(33,18,2,.25);}" +
    "#mdi-trio-upsell-overlay .mdi-upsell-badge-wrap{display:flex;justify-content:center;margin-bottom:14px;}" +
    "#mdi-trio-upsell-overlay .mdi-upsell-badge{background:#F6DED0;color:#8A4A2C;font-size:11.5px;font-weight:600;letter-spacing:.4px;padding:6px 14px;border-radius:999px;text-transform:uppercase;}" +
    "#mdi-trio-upsell-overlay .mdi-upsell-heading{margin:0 0 8px;font-size:20px;line-height:1.25;font-weight:600;color:#241609;text-align:center;}" +
    "#mdi-trio-upsell-overlay .mdi-upsell-body{margin:0 0 16px;font-size:13.5px;line-height:1.55;color:#6B5744;text-align:center;}" +
    "#mdi-trio-upsell-overlay .mdi-upsell-price-row{display:flex;align-items:center;justify-content:space-between;gap:12px;background:#FFFFFF;border:1px solid #F0E3D3;border-radius:16px;padding:14px 16px;margin-bottom:12px;}" +
    "#mdi-trio-upsell-overlay .mdi-upsell-price-label{font-size:12px;color:#8A7562;margin-bottom:4px;}" +
    "#mdi-trio-upsell-overlay .mdi-upsell-price-values{display:flex;align-items:baseline;gap:8px;}" +
    "#mdi-trio-upsell-overlay .mdi-upsell-price-old{font-size:13px;color:#B3A28F;text-decoration:line-through;}" +
    "#mdi-trio-upsell-overlay .mdi-upsell-price-new{font-size:22px;font-weight:700;color:#198754;}" +
    "#mdi-trio-upsell-overlay .mdi-upsell-save{background:#EAF3E8;color:#4C7A44;font-size:12px;font-weight:600;padding:6px 10px;border-radius:10px;white-space:nowrap;}" +
    "#mdi-trio-upsell-overlay .mdi-upsell-shipping{display:flex;align-items:center;gap:9px;background:#FBF3E9;border-radius:14px;padding:11px 14px;margin-bottom:18px;}" +
    "#mdi-trio-upsell-overlay .mdi-upsell-shipping svg{flex-shrink:0;}" +
    "#mdi-trio-upsell-overlay .mdi-upsell-shipping span{font-size:12.5px;color:#5C4630;line-height:1.4;}" +
    "#mdi-trio-upsell-overlay .mdi-upsell-shipping strong{color:#241609;}" +
    "#mdi-trio-upsell-overlay .mdi-upsell-cta{display:block;width:100%;border:none;cursor:pointer;background:#886544;background-image:linear-gradient(rgba(255,255,255,.15),rgba(255,255,255,0));color:#fff;font-family:'Poppins',system-ui,sans-serif;font-size:14.5px;font-weight:600;padding:15px 18px;border-radius:16px;box-shadow:0 8px 18px -6px rgba(136,101,68,.55);}" +
    "#mdi-trio-upsell-overlay .mdi-upsell-cta:disabled{opacity:.7;cursor:default;}" +
    "#mdi-trio-upsell-overlay .mdi-upsell-decline-wrap{text-align:center;margin-top:14px;}" +
    "#mdi-trio-upsell-overlay .mdi-upsell-decline{font-size:12.5px;color:#9C8874;text-decoration:underline;text-decoration-color:rgba(156,136,116,.4);text-underline-offset:3px;}" +
    "@media (max-width:480px){#mdi-trio-upsell-overlay{align-items:flex-end;padding:0;}#mdi-trio-upsell-overlay .mdi-upsell-card{max-width:100%;border-radius:22px 22px 0 0;max-height:85vh;}}";
  document.head.appendChild(style);
})();